<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="articles" title="Articles" />
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card" v-for="item in listData" :key="item.host">
            <TableBlogs :id="item.id" :categories="item.categories" :currency="item.currency" :host="item.host" :language="item.language">
            </TableBlogs>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
  
<script>
import firebase from '@/utils/firestore-shim';
import TableBlogs from "./articles/TableBlogs.vue";
import Cookies from 'js-cookie';
export default {
  components: { TableBlogs },
  data() {
    return {
      listData: []
    };
  },
  async mounted() {
    this.listData = await this.getStoresData();
  },
  methods: {
    async getStoresData() {
      let listData = [];
      var ProductRef = await firebase.firestore().collection("Sites")
        .where("host", "==", this.getStore())
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listData.push(
              doc.data()
            );
          });
        });
      return listData;

    },
    getStore() {
      const host = Cookies.get('hostCookie');
      if (host) {
        return host;
      } else {
        this.$router.push('/dashboard/default');
      }
    },
  }
}
</script>
  
<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>